import { render, staticRenderFns } from "./QuestionbankMsg.vue?vue&type=template&id=0ef6a6c7&"
import script from "./QuestionbankMsg.vue?vue&type=script&lang=js&"
export * from "./QuestionbankMsg.vue?vue&type=script&lang=js&"
import style0 from "./QuestionbankMsg.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports